import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import DefaultNoPhoto from "../../assets/default-no-photo.jpg";
import NavigationSwiper from "./NavigationSwiper";

import "swiper/css";
import "swiper/css/navigation";

const AboutWelcomeEventOrganizer = ({ opacityPercent = 80 }) => {
  const decimalOpacity = opacityPercent / 100;

  const hospitals = [
    { name: "Siloam Heart Hospital", img: "/hospitals/heart.jpg" },
    { name: "Siloam Hospital Lippo Village", img: "/hospitals/lippo.jpg" },
    { name: "Siloam Hospital TB Simatupang", img: "/hospitals/tb.jpg" },
    { name: "Siloam Hospital Kebon Jeruk", img: "/hospitals/kj.jpg" },
    { name: "Siloam Hospital Surabaya", img: "/hospitals/sby.jpg" },
    { name: "Siloam Hospital Makassar", img: "/hospitals/mks.jpg" },
    { name: "Siloam Hospital Denpasar", img: "/hospitals/dps.jpg" },
  ];

  return (
    <div className="relative group px-4">
      <Swiper
        modules={[Navigation, Autoplay]}
        spaceBetween={20}
        slidesPerView={2}
        breakpoints={{
          640: { slidesPerView: 3 },
          1024: { slidesPerView: 4 },
        }}
        navigation={{
          nextEl: ".swiper-button-next-custom",
          prevEl: ".swiper-button-prev-custom",
        }}
        autoplay={{ delay: 5000, disableOnInteraction: false }}
        className="pb-4"
      >
        {hospitals.map((h, i) => (
          <SwiperSlide key={i}>
            {/* Mengatur opacity pada wrapper slide */}
            <div 
              style={{ opacity: decimalOpacity }}
              className="group cursor-pointer py-2 transition-opacity duration-500"
            >
              <div className="overflow-hidden rounded-2xl aspect-video mb-4 shadow-sm border border-slate-100 dark:border-slate-800 bg-slate-50 dark:bg-slate-800">
                <img 
                  src={h.img} 
                  alt={h.name} 
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" 
                  onError={(e) => {
                    e.target.src = DefaultNoPhoto;
                  }}
                />
              </div>
              <p className="text-[9px] md:text-[10px] font-black text-center uppercase tracking-widest text-slate-400 group-hover:text-blue-600 transition-colors duration-300">
                {h.name}
              </p>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Kirim prop opacity ke NavigationSwiper */}
      <NavigationSwiper opacity={opacityPercent} />
    </div>
  );
};

export default AboutWelcomeEventOrganizer;